var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _path2, _path3, _circle7, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 201,
    viewBox: "0 0 200 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100.43,
    r: 100,
    fill: "url(#paint0_linear_621_17053)",
    fillOpacity: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100.43,
    r: 99.8236,
    stroke: "url(#paint1_linear_621_17053)",
    strokeOpacity: 0.18,
    strokeWidth: 0.352734,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.176,
    cy: 100.605,
    r: 79.9296,
    fill: "url(#paint2_linear_621_17053)",
    fillOpacity: 0.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.176,
    cy: 100.605,
    r: 79.7508,
    stroke: "url(#paint3_linear_621_17053)",
    strokeOpacity: 0.18,
    strokeWidth: 0.357627,
    strokeLinecap: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.176,
    cy: 100.604,
    r: 59.1549,
    fill: "url(#paint4_linear_621_17053)",
    fillOpacity: 0.8
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.176,
    cy: 100.604,
    r: 59.0017,
    stroke: "url(#paint5_linear_621_17053)",
    strokeOpacity: 0.18,
    strokeWidth: 0.306502,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1338 88.6971C30.6562 87.6445 57.2936 72.2031 57.2936 72.2031L76.8189 60.5642C78.2624 59.7037 80.1312 60.1968 80.9623 61.6574L90.3861 78.2185L117.907 125.205C118.93 126.95 118.929 127.732 116.54 129.132L69.095 156.922C67.5584 157.822 65.8529 158.039 64.8304 156.293C63.8079 154.548 28.3992 94.4139 27.5958 92.724C26.7923 91.0341 27.6114 89.7498 29.1338 88.6971Z",
    fill: "white",
    stroke: "#6C757D",
    strokeOpacity: 0.12,
    strokeWidth: 0.474687,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124.05 63.3028L152.253 79.7233L172.285 90.9794C173.768 91.8125 174.262 93.7103 173.374 95.1609L161.365 114.781C161.365 114.781 136.318 153.603 135.124 155.655C133.93 157.706 133.189 158.19 130.797 156.797L83.2851 129.134C83.2677 129.124 83.2762 129.12 83.2704 129.101L81.976 124.739C81.9696 124.717 81.9574 124.718 81.9694 124.699C82.3757 124.048 118.365 66.3855 119.552 64.3458C120.746 62.2945 122.341 62.3076 124.05 63.3028Z",
    fill: "white",
    stroke: "#6C757D",
    strokeOpacity: 0.12,
    strokeWidth: 0.474687,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6182 65.4414H105.404H132.516C132.562 65.4414 132.6 65.4792 132.6 65.5257V92.8483V160.944C132.6 163.474 132.177 164.317 129.227 164.317H70.6182C68.7199 164.317 67.0342 163.474 67.0342 160.944C67.0341 158.414 67.0346 71.3444 67.0342 68.8146C67.0338 66.2847 68.5099 65.4414 70.6182 65.4414Z",
    fill: "white",
    stroke: "#6C757D",
    strokeOpacity: 0.12,
    strokeWidth: 0.505974,
    strokeLinecap: "round"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 99.502,
    cy: 127.844,
    r: 24,
    fill: "#1819B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.467 123.224C99.5367 123.154 99.6194 123.099 99.7106 123.061C99.8017 123.023 99.8994 123.004 99.998 123.004C100.097 123.004 100.194 123.023 100.285 123.061C100.377 123.099 100.459 123.154 100.529 123.224L103.529 126.224C103.599 126.294 103.654 126.377 103.692 126.468C103.73 126.559 103.749 126.657 103.749 126.755C103.749 126.854 103.73 126.952 103.692 127.043C103.654 127.134 103.599 127.217 103.529 127.286C103.459 127.356 103.377 127.411 103.285 127.449C103.194 127.487 103.097 127.506 102.998 127.506C102.899 127.506 102.802 127.487 102.711 127.449C102.62 127.411 102.537 127.356 102.467 127.286L100.748 125.566V131.255C100.748 131.454 100.669 131.645 100.528 131.786C100.388 131.926 100.197 132.005 99.998 132.005C99.7991 132.005 99.6083 131.926 99.4677 131.786C99.327 131.645 99.248 131.454 99.248 131.255V125.566L97.529 127.286C97.3882 127.427 97.1972 127.506 96.998 127.506C96.7989 127.506 96.6078 127.427 96.467 127.286C96.3262 127.145 96.2471 126.954 96.2471 126.755C96.2471 126.556 96.3262 126.365 96.467 126.224L99.467 123.224Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.609 120.517C96.1082 119.224 98.0204 118.51 100 118.504C104.035 118.504 107.385 121.504 107.749 125.372C110.137 125.71 112 127.709 112 130.163C112 132.857 109.753 135.004 107.031 135.004H93.6715C90.562 135.004 88 132.553 88 129.481C88 126.836 89.899 124.646 92.413 124.091C92.6275 122.797 93.46 121.507 94.609 120.517ZM95.5885 121.652C94.453 122.632 93.859 123.812 93.859 124.736V125.408L93.1915 125.482C91.096 125.711 89.5 127.432 89.5 129.481C89.5 131.681 91.345 133.504 93.6715 133.504H107.031C108.97 133.504 110.5 131.986 110.5 130.163C110.5 128.339 108.97 126.821 107.031 126.821H106.281V126.071C106.282 122.741 103.492 120.004 100 120.004C98.3798 120.01 96.8153 120.594 95.5885 121.652Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_621_17053",
    x1: 100,
    y1: 0.429688,
    x2: 100.176,
    y2: 100.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F7FA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_621_17053",
    x1: 100,
    y1: 0.429688,
    x2: 105.115,
    y2: 103.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C757D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C757D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_621_17053",
    x1: 100.176,
    y1: 20.6758,
    x2: 100.176,
    y2: 96.5561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F7FA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_621_17053",
    x1: 100.176,
    y1: 20.6758,
    x2: 100.176,
    y2: 105.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C757D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C757D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_621_17053",
    x1: 100.176,
    y1: 41.4492,
    x2: 100.176,
    y2: 117.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F7FA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_621_17053",
    x1: 100.176,
    y1: 41.4492,
    x2: 100.176,
    y2: 107.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C757D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C757D",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon2);
export default __webpack_public_path__ + "static/media/UploadIcon2.f6cde7143e5ef4e64d8cdc46607cf42e.svg";
export { ForwardRef as ReactComponent };